import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import {
  Grid,
  Paper,
  TextField,
  Typography,
  Autocomplete,
  Toolbar,
  Chip,
  Divider,
  FormControlLabel,
  Checkbox,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Modal,
  Box,
  createFilterOptions,
  Button,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import HelpCenterIcon from "@mui/icons-material/HelpCenter";
import axiosWithToken from "../../utils/commonComponent/axiosTokenConfig";
import { BASE_URL, MAX_COLS } from "../../global";
import CButton from "../../utils/commonComponent/CButton";
import {
  AddButton,
  CancelButton,
  SaveAndUpdate,
} from "../../utils/commonComponent/Custom/Button";
const filter = createFilterOptions();

const extraPrecisionSplitter = " + ";
export const UNCERTAINTY_LINK = "__";
export const EXTRA_COLUMN_LINK = "__";

const DEFAULT_TEST_DETAIL_FIELDS = [
  { label: "Diameter of Specimen (cm)" },
  { label: "Length of Specimen (cm)" },
  { label: "Area of Specimen (cm²)" },
];

const EditTemplate = () => {
  const navigate = useNavigate();
  const [rangeCol, setRangeCol] = useState("");
  const [datasheetColumnName, setDatasheetColumnName] = useState([]);
  const [datasheetConfiguration, setDatasheetConfiguration] = useState({
    values: {},
    formulas: {},
    totalColumns: 0,
    hasCommonHeader: false,
    commonHeaderConfig: null,
    referenceImageUpload: "",
    uncertaintyReferenceType: 0,
    budget: {
      formulas: {},
    },
    printConfig: {
      datasheetColumnHide: "",
      printCommonHeaderConfig: null,
    },
  });
  const [certificateColumnName, setCertificateColumnName] = useState([]);
  const [certificateConfiguration, setCertificateConfiguration] = useState({
    relations: {},
    totalColumns: 0,
    hasCommonHeader: false,
    commonHeaderConfig: null,
  });
  const [condConfiguration, setCondConfiguration] = useState({
    relations: {},
  });
  const [customPrecision, setCustomPrecision] = useState({});
  const [typeBConfiguration, setTypeBConfiguration] = useState({
    relations: {},
  });
  const [summaryColumns, setSummaryColumns] = useState([]);
  const [additionalTestDetails, setAdditionalTestDetails] = useState([]);

  const [selectedValueCol, setSelectedValueCol] = useState(null);
  const [selectedFormulaCol, setSelectedFormulaCol] = useState(null);
  const [selectedCondition, setSelectedCondition] = useState("default");
  const [selectedFormulaCol1, setSelectedFormulaCol1] = useState(null);
  const [dsCol, setDsCol] = useState(null);
  const [dsCol2, setDsCol2] = useState(null);
  const [plusPrecision, setPlusPrecision] = useState("");
  const [stdRangePref, setStdRangePref] = useState("null");
  const [conditionsCol, setConditionsCol] = useState(null);

  const [selectedDatasheetRelCol, setSelectedDatasheetRelCol] = useState(null);
  const [selectedCertRelCol, setSelectedCertRelCol] = useState(null);

  var [materialArray, setMaterialArray] = useState([]);
  const [testList, settestList] = useState([]);
  const [seletedtedTestID, setseletedtedTestID] = useState("");
  var [uncertaintyFactors, setUncertaintyFactors] = useState([]);
  const [isUncertainty, setUncertainty] = useState(false);
  const [isUncertaintyCertificate, setUncertaintyCertificate] = useState(false);
  const [sketchPickerColor, setSketchPickerColor] = useState("#D12929");
  const [certificateTableStatus, setCertificateTableStatus] = useState(1);
  const [isComplianceStatus, setIsComplianceStatus] = useState({
    datasheet: 0,
    certificate: 0,
  });
  const [isGauge, setGauge] = useState(false);
  const [stdFilteration, setStdFilteration] = useState(false);

  const [tableName, setTableName] = useState("");
  const [materialId, setMaterialId] = useState("");
  const [materialName, setMaterialName] = useState("");
  const [defaultConfiguration, setDefaultConfiguration] = useState("");
  const [showHeader, setShowHeader] = useState(true);
  const [tableInstruction, setTableInstruction] = useState("");
  const [editAccess, setEditAccess] = React.useState(
    localStorage.getItem("editAccess")?.split(",").map(Number)
  );

  const [settingList, setsettingList] = useState({
    referenceImageUploadDatasheet: false,
    complianceStatus: false,
  });
  // destructuring rgba from state
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const params = useParams();

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    bgcolor: "background.paper",
    boxShadow: 24,
    p: 4,
  };

  const onSubmit = () => {
    function formate(obj) {
      const formattedObj = JSON.parse(JSON.stringify(obj));
      function removeEmptyStringsAndObjects(obj) {
        for (let key in obj) {
          if (typeof obj[key] === "object" && obj[key] !== null) {
            removeEmptyStringsAndObjects(obj[key]);
            if (Object.keys(obj[key]).length === 0) {
              delete obj[key];
            }
          } else if (obj[key] === "") {
            delete obj[key];
          }
        }
      }
      // Remove empty strings and objects in "values"
      removeEmptyStringsAndObjects(formattedObj.values);
      // Remove empty strings and objects in "formulas"
      removeEmptyStringsAndObjects(formattedObj.formulas);
      // Remove empty strings in "readingGroupByConfig"
      if (formattedObj?.readingGroupByConfig === "") {
        delete formattedObj?.readingGroupByConfig;
      }
      return formattedObj;
    }
    const removeEmptyString = formate(datasheetConfiguration);

    var jsonData = {
      tableName: tableName,
      tableInstructions: tableInstruction,
      materialId: materialId,
      testId: seletedtedTestID,
      defaultConfiguration: JSON.stringify({
        ...removeEmptyString,
        typeb: typeBConfiguration,
        rangeCol: rangeCol,
        isGauge: isGauge,
        stdFilteration: stdFilteration,
      }),
      conditionFormatting: JSON.stringify({
        ...condConfiguration,
      }),
      customPrecision: JSON.stringify({
        ...customPrecision,
      }),
      additionalTestDetails: JSON.stringify(additionalTestDetails),
      isUncertainty: isUncertainty,
      isComplianceStatus: isComplianceStatus.datasheet,
      summaryColumn: summaryColumns.join(',') || null,
    };
    for (let i = 1; i < MAX_COLS + 1; i++) jsonData["c" + i] = null;
    datasheetColumnName.forEach((column, index) => {
      jsonData["c" + (index + 1)] = column;
    });

    let url = BASE_URL;
    if (params.id > 0) {
      axiosWithToken
        .patch(url + `observationTemplates/${params.id}`, jsonData)
        .then((res) => {
          submitCertificate();
        })
        .catch((error) => console.log(error));
    } else {
      axiosWithToken
        .post(url + "observationTemplates", jsonData)
        .then((res) => {
          submitCertificate();
        })
        .catch((error) => console.log(error));
    }
  };

  const submitCertificate = () => {
    var jsonData = {
      tableName: tableName,
      materialId: materialId,
      testId: seletedtedTestID,
      defaultConfiguration: JSON.stringify({
        ...certificateConfiguration,
        showHeader,
      }),
      isUncertainty: isUncertaintyCertificate,
      status: certificateTableStatus,
      isComplianceStatus: isComplianceStatus.certificate,
    };
    for (let i = 1; i < MAX_COLS + 1; i++) jsonData["c" + i] = null;
    certificateColumnName.forEach((column, index) => {
      jsonData["c" + (index + 1)] = column;
    });

    if (params.id > 0) {
      axiosWithToken
        .patch(BASE_URL + `certificateTemplates/${params.id}`, jsonData)
        .then((res) => {
          // props.setLoader(false);
          toast("Table updated!");
          window.location.reload();
        })

        .catch((error) => console.log(error));
    } else {
      axiosWithToken
        .post(BASE_URL + `certificateTemplates`, jsonData)
        .then((res) => {
          // props.setLoader(false);
          toast("new table added!");
          setTimeout(() => navigate("/master/templateList"), 1000);
        })
        .catch((error) => console.log(error));
    }
  };

  const addDatasheetColumn = () => {
    setDatasheetColumnName([...datasheetColumnName, ""]);
    updateDatasheetConfiguration(
      "totalColumns",
      null,
      Number(datasheetConfiguration["totalColumns"]) + 1
    );
  };

  const deleteDatasheetColumn = (index) => {
    let newDatasheetColumnName = [...datasheetColumnName];
    newDatasheetColumnName.splice(index, 1);
    setDatasheetColumnName([...newDatasheetColumnName]);
  };
  const updateDatasheetColumnName = (value, index) => {
    const newColumnName = [...datasheetColumnName];
    newColumnName[index] = value;
    setDatasheetColumnName(newColumnName);
  };

  const updateDatasheetConfiguration = (type, column, value) => {
    let _datasheetConfiguration = { ...datasheetConfiguration };
    if (type === "formulas") {
      if (
        Object.keys(_datasheetConfiguration[type][column] || {}).length == 0
      ) {
        _datasheetConfiguration[type][column] = {};
      }
      _datasheetConfiguration[type][column][selectedCondition || "default"] =
        value;
    } else if (type === "budget.formulas") {
      if (Object.keys(_datasheetConfiguration["budget"] || {}).length == 0) {
        _datasheetConfiguration["budget"] = {
          formulas: {},
        };
      }
      if (
        Object.keys(_datasheetConfiguration["budget"]["formulas"][column] || {})
          .length == 0
      ) {
        _datasheetConfiguration["budget"]["formulas"][column] = {};
      }
      _datasheetConfiguration["budget"]["formulas"][column][
        selectedCondition || "default"
      ] = value;
    } else if (type === "printConfig.printCommonHeaderConfig") {
      _datasheetConfiguration["printConfig"].printCommonHeaderConfig = value;
    } else if (column != null) {
      _datasheetConfiguration[type][column] = value;
    } else {
      _datasheetConfiguration[type] = value;
    }

    setDatasheetConfiguration(_datasheetConfiguration);
  };

  const updateCertificateConfiguration = (
    type,
    column = null,
    value = null
  ) => {
    let _certificateConfiguration = { ...certificateConfiguration };
    if (column != null) {
      _certificateConfiguration[type][column] = value;
    } else if (
      type === "relations" &&
      selectedCertRelCol &&
      selectedDatasheetRelCol
    ) {
      _certificateConfiguration[type][selectedCertRelCol] =
        selectedDatasheetRelCol;
    } else {
      _certificateConfiguration[type] = value;
    }
    setCertificateConfiguration(_certificateConfiguration);
  };

  const condConfObj = {
    gt: "Greater than",
    lt: "Less than",
    between: "Between",
    precisionCountNotEqual: "Precision not equals",
    NAN: "Not A Number",
    Notbetween: "Not A Between",
    "Greater than": 1,
    "Less than": 2,
    Between: 3,
    "Precision not equals": 4,
    "Not A Number": 5,
    "Not A Between": 6,
    // "Tolerance between 5%": 7,
    1: "gt",
    2: "lt",
    3: "between",
    4: "precisionCountNotEqual",
    5: "NAN",
    6: "Notbetween",
    7: "Tolerance between 5%",
  };

  const updateConditionConfiguration = (type, column = null, value = null) => {
    let _conditionsConfiguration = { ...condConfiguration };
    if (column != null) {
      // Check if the column exists and is an array
      if (Array.isArray(_conditionsConfiguration[type][column])) {
        // Push the new value into the existing array
        _conditionsConfiguration[type][column].push(value);
      } else {
        // If it's not an array, initialize it as one with the new value
        _conditionsConfiguration[type][column] = [value];
      }
    } else if (type === "relations" && conditionsCol && selectedFormulaCol1) {
      let condition = condConfObj[conditionsCol];
      const newCondition = {
        condition: condition,
        dsCol: dsCol + "." + stdRangePref,
        color: sketchPickerColor,
      };
      // Ensure the column exists and is an array, then add the new condition
      if (_conditionsConfiguration[type][selectedFormulaCol1]) {
        if (
          Array.isArray(_conditionsConfiguration[type][selectedFormulaCol1])
        ) {
          _conditionsConfiguration[type][selectedFormulaCol1].push(
            newCondition
          );
        } else {
          _conditionsConfiguration[type][selectedFormulaCol1] = [newCondition];
        }
      } else {
        _conditionsConfiguration[type][selectedFormulaCol1] = [newCondition];
      }
    } else {
      _conditionsConfiguration[type] = value;
    }
    // Remove empty arrays from conditionsConfiguration
    Object.keys(_conditionsConfiguration[type]).forEach((key) => {
      if (
        Array.isArray(_conditionsConfiguration[type][key]) &&
        _conditionsConfiguration[type][key].length === 0
      ) {
        delete _conditionsConfiguration[type][key];
      }
    });
    setCondConfiguration(_conditionsConfiguration);
  };

  const updateCustomPrecision = (column = null, value = null) => {
    let _customPrecision = { ...customPrecision };
    _customPrecision[selectedFormulaCol1] =
      dsCol2 + extraPrecisionSplitter + plusPrecision + "." + stdRangePref;
    setCustomPrecision(_customPrecision);
  };

  const addCertificateColumn = () => {
    setCertificateColumnName([...certificateColumnName, ""]);
    updateCertificateConfiguration(
      "totalColumns",
      null,
      Number(certificateConfiguration["totalColumns"]) + 1
    );
  };

  const deleteCertificateColumn = (index) => {
    let newCertificateColumnName = [...certificateColumnName];
    newCertificateColumnName.splice(index, 1);
    setCertificateColumnName([...newCertificateColumnName]);
  };

  const updateCertificateColumnName = (value, index) => {
    const newColumnName = [...certificateColumnName];
    newColumnName[index] = value;
    setCertificateColumnName(newColumnName);
  };

  const getObservationSheet = () => {
    let url = BASE_URL;
    axiosWithToken
      .get(url + `observationTemplates/${params.id}`)
      .then((res) => {
        setMaterialId(res.data[0].materialId);
        setseletedtedTestID(res.data[0].testId);
        setTableName(res.data[0].tableName);
        setTableInstruction(res.data[0].tableInstructions);
        setUncertainty(res.data[0].isUncertainty);
        setGauge(
          res.data[0].defaultConfiguration
            ? JSON.parse(res.data[0].defaultConfiguration)?.isGauge
            : false
        );
        setStdFilteration(
          res.data[0].defaultConfiguration
            ? JSON.parse(res.data[0].defaultConfiguration)?.stdFilteration
            : false
        );
        setIsComplianceStatus((prevState) => ({
          ...prevState,
          datasheet: res.data[0].isComplianceStatus,
        }));
        setDatasheetConfiguration(
          res.data[0].defaultConfiguration != null
            ? JSON.parse(res.data[0].defaultConfiguration)
            : {}
        );
        setTypeBConfiguration(
          res.data[0].defaultConfiguration != null
            ? JSON.parse(res.data[0].defaultConfiguration).typeb
              ? JSON.parse(res.data[0].defaultConfiguration).typeb
              : {}
            : {}
        );
        if (res.data[0].summaryColumn) {
          setSummaryColumns(res.data[0].summaryColumn.split(','));
        }
        const conditionFormatting =
          res.data[0].conditionFormatting != null
            ? JSON.parse(res.data[0].conditionFormatting)
            : {};
        const formattedConditions = Object.entries(
          conditionFormatting.relations || {}
        ).reduce((acc, [key, value]) => {
          acc[key] = Array.isArray(value) ? value : [value];
          return acc;
        }, {});
        setCondConfiguration({ relations: formattedConditions });
        setCustomPrecision(
          res.data[0].customPrecision != null
            ? JSON.parse(res.data[0].customPrecision)
            : {}
        );
        const columnArr = [];
        for (let i = 1; i < MAX_COLS + 1; i++) {
          columnArr.push(res.data[0]?.["c" + i]);
        }

        setDatasheetColumnName(
          columnArr.filter(function (el) {
            return el != null;
          })
        );
        let rangeCol = JSON.parse(res.data[0].defaultConfiguration).rangeCol;
        setRangeCol(rangeCol);
        const additionalTestDetailsRaw = res.data[0].additionalTestDetails && JSON.parse(res.data[0].additionalTestDetails);
        setAdditionalTestDetails(additionalTestDetailsRaw || []);
      })
      .catch((error) => {
        if (error.message !== "request_aborted") {
          toast.error("Something Went Wrong!");
        }
      });
  };

  const getCertificate = () => {
    let url = BASE_URL;
    let certificateReadingColumnNames = [];
    for (let i = 1; i < MAX_COLS + 1; i++) {
      certificateReadingColumnNames.push(`cert.c${i}`);
    }
    certificateReadingColumnNames = certificateReadingColumnNames.join(",");

    axiosWithToken
      .get(url + `certificateTemplates/${params.id}`)
      .then((res) => {
        setCertificateTableStatus(res.data[0].status);
        setUncertaintyCertificate(res.data[0].isUncertainty);
        setIsComplianceStatus((prevState) => ({
          ...prevState,
          certificate: res.data[0].isComplianceStatus,
        }));
        setCertificateConfiguration(
          res.data[0].defaultConfiguration != null
            ? JSON.parse(res.data[0].defaultConfiguration)
            : {}
        );
        setShowHeader(
          res.data[0].defaultConfiguration != null
            ? JSON.parse(res.data[0].defaultConfiguration)?.showHeader
            : true
        );
        setDefaultConfiguration(res.data[0].defaultConfiguration);
        const columnArr = [];

        for (let i = 1; i < MAX_COLS + 1; i++) {
          columnArr.push(res.data[0]?.["c" + i]);
        }

        setCertificateColumnName(
          columnArr.filter(function (el) {
            return el != null;
          })
        );
      })
      .catch((error) => {
        if (error.message !== "request_aborted") {
          toast.error("Something Went Wrong!");
        }
      });
  };

  const getMaterialList = () => {
    let url = BASE_URL;
    axiosWithToken
      .get(url + "materialScope?_where=(status,eq,1)")
      .then((res) => {
        setMaterialArray(res.data);
      })
      .catch((error) => {
        if (error.message !== "request_aborted") {
          toast.error("Something Went Wrong!");
        }
      });
  };

  const getTestList = () => {
    let url = BASE_URL;
    axiosWithToken
      .get(
        url +
          `materialTestings?_where=(status,eq,1)~and(materialId,eq,${materialId})`
      )
      .then((res) => {
        settestList(res.data);
      })
      .catch((error) => console.log(error));
  };

  useEffect(() => {
    if (materialId) {
      let currentMaterialName = materialArray?.find(
        (material) => material.id == materialId
      )?.MaterialName;
      setMaterialName(currentMaterialName);
      getTestList();
    }
}, [materialId, materialArray]); // Added materialArray to dependencies

  const fetchUncertaintyFactors = () => {
    let filteredMaterial = materialArray?.find(
      (material) => material.id == materialId
    );
    if (!filteredMaterial) return;
    const { uncertaintyFactors, commonUncertaintyFactors } = filteredMaterial;

    const allFactorsIds = [
      ...(uncertaintyFactors?.split(",") || []),
      ...(commonUncertaintyFactors?.split(",") || []),
    ];
    const extractedUncertaintyIds = allFactorsIds?.map((id) =>
      id?.split(":")?.pop()
    );
    const uniqueIds = [...new Set(extractedUncertaintyIds)]?.join(",");

    if (!uniqueIds) return;
    axiosWithToken
      .get(BASE_URL + `uncertainty?_where=(id,in,${uniqueIds})`)
      .then((res) => {
        setUncertaintyFactors([...res.data]);
      })
      .catch((error) => {
        if (error.message !== "request_aborted") {
          toast.error("Failed to uncertainty factors!");
        }
      });
  };

  function fetchSettings() {
    axiosWithToken
      .get(BASE_URL + `settings`)
      .then((res) => {
        let referenceImageUpload = false,
          complianceStatus = false;
        res?.data?.forEach((setting) => {
          if (
            setting.keyName === "tableTemplateReferenceimgDatasheet" &&
            setting.value.toLowerCase() === "true"
          ) {
            referenceImageUpload = true;
          } else if (
            setting.keyName === "tableTemplateComplianceStatus" &&
            setting.value.toLowerCase() === "true"
          ) {
            complianceStatus = true;
          }
        });
        setsettingList({
          referenceImageUploadDatasheet: referenceImageUpload,
          complianceStatus: complianceStatus,
        });
      })
      .catch((err) => console.error("Error fetching setting:", err));
  }

  useEffect(() => {
    fetchSettings();
    getMaterialList();
    if (params.id > 0) {
      getObservationSheet();
      getCertificate();
    }
  }, []);

  useEffect(() => {
    // if (params.id > 0) {
    fetchUncertaintyFactors();
    // }
  }, [materialArray, materialId]);

  const renderHelpModal = () => {
    return (
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            Formula Help
          </Typography>
          <Typography id="modal-modal-description" sx={{ mt: 2 }}>
            same as mathematical expression with following variations
            <hr />
            <ul>
              <li>
                1. multiplication: <code>*</code>
              </li>
              <li>
                2. for power:{" "}
                <code>pow(&lt;base value&gt;, &lt;exponent&gt;)</code>
              </li>
              <li>
                3. for square root : <code>sqrt(&lt;value&gt;)</code>, value:
                either number of column code (eg. c1)
              </li>
            </ul>
          </Typography>
        </Box>
      </Modal>
    );
  };

  return (
    <>
      <Typography variant="h6" component="h6" sx={{ mb: 2, textAlign: "left" }}>
        {params.id > 0 ? "Update" : "Create new"} static table
      </Typography>
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
        <div className="w-full">
          <Autocomplete
            size="small"
            id="combo-box-demo"
            value={materialId + ", " + materialName}
            options={materialArray.map((material) => {
              return {
                label: material.id + ", " + material.MaterialName,
              };
            })}
            onChange={(event, value) => {
              if (value) {
                setMaterialId(parseInt(value.label.split(",")[0]));
                setMaterialName(value.label.split(",")[1]);
              }
            }}
            renderInput={(params) => (
              <TextField {...params} label="Material *" />
            )}
            disabled={Number(params.id) > 0}
          />
        </div>
        <div className="w-full">
          <Autocomplete
            size="small"
            id="combo-box-demo"
            options={testList}
            value={
              testList.find((test) => test.id == seletedtedTestID) || null
            }
            getOptionLabel={(option) => `${option.testName || ""} (${option.testMethod || ""})`}
            onChange={(event, value) => {
              setseletedtedTestID(value?.id);
            }}
            renderInput={(params) => (
              <TextField {...params} label="Test Name" />
            )}
            disabled={params.id != 0}
          />
        </div>
        <div className="w-full">
          <TextField
            id="outlined-basic"
            label="New table name"
            size="small"
            fullWidth
            inputProps={{
              autoComplete: "off",
            }}
            variant="outlined"
            value={tableName}
            onChange={(e) => setTableName(e.target.value)}
          />
        </div>
      </div>

      {/* ObservationSheet table confiurations */}
      <div>
        <Divider sx={{ my: 3 }}>
          <Chip
            label="ObservationSheet table configuration"
            variant="outlined"
            sx={{ fontSize: "16px", fontWeight: 600 }}
          />
        </Divider>

        <div>
          <div className="flex gap-4 items-center my-3">
            <Typography variant="h6" component="h6">
              1.
            </Typography>
            <AddButton
              id="btn-add-column"
              label="Add columns"
              icon={<AddIcon fontSize="small" />}
              onClick={() => addDatasheetColumn()}
            />
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 my-4">
            {datasheetColumnName.map((column, index) => (
              <div className="w-full">
                <OutlinedInput
                  id="outlined-adornment-password"
                  label={"column " + (index + 1) + "(c" + (index + 1) + ")"}
                  value={column}
                  placeholder={
                    "column " + (index + 1) + " (c" + +(index + 1) + ")"
                  }
                  onChange={(e) => {
                    updateDatasheetColumnName(e.target.value, index);
                  }}
                  size="small"
                  endAdornment={
                    <InputAdornment position="end">
                      <IconButton
                        onClick={() => {
                          deleteDatasheetColumn(index);
                        }}
                        edge="end"
                      >
                        <CloseIcon />
                      </IconButton>
                    </InputAdornment>
                  }
                />
              </div>
            ))}
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 gap-4">
           <div className="w-full">
              <FormControlLabel
                control={<Checkbox />}
                label="Show Column Header in Certificate"
                checked={showHeader}
                onChange={(e) => {
                  setShowHeader(e.target.checked);
                }}
              />
            </div>
          </div>
        </div>
        <div className="mt-2">
          <Typography variant="h6" component="h6">
            2. Define common header{" "}
            <CButton
              variant="text"
              size="small"
              label={<HelpCenterIcon />}
              onClick={handleOpen}
            ></CButton>
          </Typography>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 gap-4">
            <div className="w-full md:text-center">
              <FormControlLabel
                control={<Checkbox />}
                label="Has common header"
                checked={datasheetConfiguration?.hasCommonHeader}
                onChange={(e) => {
                  updateDatasheetConfiguration(
                    "hasCommonHeader",
                    null,
                    e.target.checked
                  );
                }}
              />
            </div>
            <div className="col-span-1 sm:col-span-2 md:col-span-2 lg:col-span-2">
              <TextField
                id="outlined-basic"
                label="Define common header"
                placeholder="Define common header (, for column separation, $: for empty column)"
                size="small"
                fullWidth
                variant="outlined"
                inputProps={{
                  autoComplete: "off",
                }}
                value={datasheetConfiguration?.commonHeaderConfig || ""}
                onChange={(e) =>
                  updateDatasheetConfiguration(
                    "commonHeaderConfig",
                    null,
                    e.target.value
                  )
                }
              />
            </div>
          </div>
        </div>
        <div className="mt-2">
        <Typography variant="h6" component="h6">
          3. Set default values (optional)
        </Typography>
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 my-3">
          <div className="w-full">
            <FormControl fullWidth>
              <InputLabel id="demo-simple-select-label">
                Select Column
              </InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={selectedValueCol}
                label="Select column"
                onChange={(e) => {
                  setSelectedValueCol(e.target.value);
                }}
                size="small"
              >
                {datasheetColumnName.map((columnName, index) => {
                  return (
                    <MenuItem value={"c" + (index + 1)}>{columnName}</MenuItem>
                  );
                })}
              </Select>
            </FormControl>
          </div>
          <div className="col-span-1 sm:col-span-2 md:col-span-3 lg:col-span-3">
            <TextField
              id="outlined-basic"
              label="Add values ( comma separated )"
              size="small"
              fullWidth
              variant="outlined"
              inputProps={{
                autoComplete: "off",
              }}
              value={datasheetConfiguration?.values[selectedValueCol] || ""}
              onChange={(e) =>
                updateDatasheetConfiguration(
                  "values",
                  selectedValueCol,
                  e.target.value
                )
              }
            />
          </div>
        </div>
        </div>
        <div className="mt-2">
        <Typography variant="h6" component="h6">
          4. Set formula (optional){" "}
          <CButton
            variant="text"
            size="small"
            label={<HelpCenterIcon />}
            onClick={handleOpen}
          ></CButton>
        </Typography>
          </div>
        
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 my-3">
          <div className="w-full">
            <FormControl fullWidth>
              <InputLabel id="demo-simple-select-label">
                Select column
              </InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={selectedFormulaCol}
                label="Select column"
                onChange={(e) => {
                  setSelectedFormulaCol(e.target.value);
                }}
                size="small"
              >
                {datasheetColumnName.map((columnName, index) => {
                  return (
                    <MenuItem value={"c" + (index + 1)}>{columnName}</MenuItem>
                  );
                })}
              </Select>
            </FormControl>
          </div>
          <div className="w-full">
            <Autocomplete
              value={selectedCondition}
              onChange={(event, newValue) => {
                if (typeof newValue === "string") {
                  setSelectedCondition(newValue);
                } else if (newValue && newValue.inputValue) {
                  setSelectedCondition(newValue.inputValue);
                } else {
                  setSelectedCondition(newValue);
                }
              }}
              filterOptions={(options, params) => {
                const filtered = filter(options, params);

                const { inputValue } = params;
                // Suggest the creation of a new value
                const isExisting = options.some(
                  (option) => inputValue === option
                );
                if (inputValue !== "" && !isExisting) {
                  filtered.push(inputValue);
                }

                return filtered;
              }}
              selectOnFocus
              clearOnBlur
              handleHomeEndKeys
              id="free-solo-with-text-demo"
              options={Object.keys(
                datasheetConfiguration?.formulas[selectedFormulaCol] || {
                  default: "",
                }
              )}
              getOptionLabel={(option) => {
                // Value selected with enter, right from the input
                if (typeof option === "string") {
                  return option;
                }
                // Add "xxx" option created dynamically
                if (option.inputValue) {
                  return option.inputValue;
                }
              }}
              renderOption={(props, option) => (
                <li {...props} style={{ display: "flex" }}>
                  <div style={{ flex: "1" }}>{option}</div>
                  <button
                    style={{ color: "#888" }}
                    onClick={(e) => {
                      let tmpDt = { ...datasheetConfiguration };
                      let tmp = tmpDt?.formulas[selectedFormulaCol];
                      delete tmp[props["key"]];
                      if (Object.keys(tmp).length === 0)
                        delete tmpDt.formulas[selectedFormulaCol];
                      else tmpDt.formulas[selectedFormulaCol] = tmp;
                      setDatasheetConfiguration(tmpDt);
                      setSelectedCondition("");
                    }}
                  >
                    <svg
                      className="MuiSvgIcon-root MuiSvgIcon-fontSizeSmall css-ptiqhd-MuiSvgIcon-root"
                      focusable="false"
                      aria-hidden="true"
                      viewBox="0 0 24 24"
                      data-testid="CloseIcon"
                    >
                      <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"></path>
                    </svg>
                  </button>
                </li>
              )}
              freeSolo
              renderInput={(params) => (
                <TextField {...params} label="Set condition" />
              )}
              size="small"
            />
          </div>
          <div className="col-span-1 sm:col-span-2 md:col-span-2 lg:col-span-2">
            <TextField
              id="outlined-basic"
              label="Add formula"
              size="small"
              fullWidth
              variant="outlined"
              inputProps={{
                autoComplete: "off",
              }}
              value={
                datasheetConfiguration?.formulas?.[selectedFormulaCol]?.[
                  selectedCondition
                ] || ""
              }
              onChange={(e) =>
                updateDatasheetConfiguration(
                  "formulas",
                  selectedFormulaCol,
                  e.target.value
                )
              }
            />
            <div style={{ display: "flex", marginTop: "5px" }}>
              <Chip
                variant="outlined"
                label="range higher"
                onClick={() => {
                  updateDatasheetConfiguration(
                    "formulas",
                    selectedFormulaCol,
                    (datasheetConfiguration?.formulas[selectedFormulaCol]?.[
                      selectedCondition
                    ] || "") + " range_high "
                  );
                }}
              />
              <Chip
                variant="outlined"
                label="range lower"
                onClick={() => {
                  updateDatasheetConfiguration(
                    "formulas",
                    selectedFormulaCol,
                    (datasheetConfiguration?.formulas[selectedFormulaCol]?.[
                      selectedCondition
                    ] || "") + " range_low "
                  );
                }}
              />
              <Chip
                variant="outlined"
                label="LC"
                onClick={() => {
                  updateDatasheetConfiguration(
                    "formulas",
                    selectedFormulaCol,
                    (datasheetConfiguration?.formulas[selectedFormulaCol]?.[
                      selectedCondition
                    ] || "") + " lc "
                  );
                }}
              />
              <Chip
                variant="outlined"
                label="accuracy"
                onClick={() => {
                  updateDatasheetConfiguration(
                    "formulas",
                    selectedFormulaCol,
                    (datasheetConfiguration?.formulas[selectedFormulaCol]?.[
                      selectedCondition
                    ] || "") + " accuracy "
                  );
                }}
              />
            </div>
          </div>
        </div>

        <div>
          <Typography variant="h6" component="h6">
            5. Conditional Formatting
          </Typography>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4 my-4">
            <div className="w-full">
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">
                  Select ObservationSheet Column
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={selectedFormulaCol1}
                  label="Select column"
                  onChange={(e) => {
                    setSelectedFormulaCol1(e.target.value);
                  }}
                  size="small"
                >
                  {datasheetColumnName.map((columnName, index) => {
                    return (
                      <MenuItem value={"c" + (index + 1)}>
                        {columnName}
                      </MenuItem>
                    );
                  })}
                  <MenuItem value={"uncertainty"}>{"Uncertainty"}</MenuItem>
                </Select>
              </FormControl>
            </div>
            <div className="w-full">
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">Condition</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={conditionsCol}
                  label="Select condition"
                  onChange={(e) => {
                    // setSelectedFormulaCol(e.target.value);
                    setConditionsCol(e.target.value);
                  }}
                  size="small"
                >
                  {[
                    "Greater than",
                    "Less than",
                    "Between",
                    "Precision not equals",
                    "Not A Number",
                    "Not A Between",
                    "Tolerance between 5%",
                  ].map((columnName, index) => {
                    return <MenuItem value={index + 1}>{columnName}</MenuItem>;
                  })}
                </Select>
              </FormControl>
            </div>
            <div className="w-full">
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">
                  Select Columns
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={dsCol}
                  label="Select column"
                  onChange={(e) => {
                    setDsCol(e.target.value);
                    // setSelectedFormulaCol(e.target.value);
                  }}
                  size="small"
                >
                  {[
                    // "",
                    // "DUC Range",
                    // "DUC LC",
                    // "Master Range LC",
                    // "accuracy",
                    // "Master LC",
                    // "Master Range",
                    ...datasheetColumnName,
                  ].map((columnName, index) => {
                    // preapre items above ObservationSheet cols
                    let aboveDsItems = 0;
                    if (index < aboveDsItems)
                      return (
                        <MenuItem value={index + 1}>{columnName}</MenuItem>
                      );
                    else
                      return (
                        <MenuItem value={"ds" + (index - aboveDsItems + 1)}>
                          Datasheet: {columnName}
                        </MenuItem>
                      );
                  })}
                </Select>
              </FormControl>
            </div>
            {dsCol == 4 || dsCol == 7 ? (
              <div className="w-full">
                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">
                    Select Std. Pref.
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={stdRangePref}
                    label="Select column"
                    onChange={(e) => {
                      setStdRangePref(e.target.value);
                      // setSelectedFormulaCol(e.target.value);
                    }}
                    size="small"
                  >
                    {["NA", "1", "2", "3", "4"].map((columnName, index) => {
                      return <MenuItem value={index}>{columnName}</MenuItem>;
                    })}
                  </Select>
                </FormControl>
              </div>
            ) : (
              ""
            )}
            <div className="flex items-center gap-3">
              <input
                type="color"
                value={sketchPickerColor}
                style={{
                  backgroundColor: `${sketchPickerColor}`,
                  width: 70,
                  height: 40,
                  border: "1px solid white",
                  borderRadius: "20px",
                }}
                onChange={(e) => {
                  setSketchPickerColor(e.target.value);
                }}
              />
              <CButton
                variant="outlined"
                label={"add"}
                onClick={(e) => updateConditionConfiguration("relations")}
              ></CButton>
            </div>
          </div>
          <Grid container spacing={1} sx={{ mb: 3 }}>
            <Grid item xs={4} align="left">
              <h6>relations:</h6>
              <table className="w-full border border-gray-300 border-collapse text-center text-sm">
                <tr className="bg-gray-100">
                  <th className="border border-gray-300 p-2 w-[200px]">
                      ObservationSheet Column
                  </th>
                  <th className="border border-gray-300 p-2 w-[200px]">
                    Condition
                  </th>
                  <th className="border border-gray-300 p-2 w-[200px]">
                    Target Column
                  </th>
                  <th className="border border-gray-300 p-2 w-[200px]">
                    Color
                  </th>
                  <th className="border border-gray-300 p-2 w-[200px]">
                    Action
                  </th>
                </tr>
                {Object.keys(condConfiguration.relations).map((dC) => {
                  const conditions = condConfiguration.relations[dC];
                  return Array.isArray(conditions) ? (
                    conditions.map((condition, index) => (
                      <tr
                        key={`${dC}-${index}`}
                        className="border-t border-gray-300"
                      >
                        <td className="border border-gray-300 p-2">
                          {dC.startsWith("c")
                            ? datasheetColumnName[Number(dC.split("c")[1]) - 1]
                            : dC}
                        </td>
                        <td className="border border-gray-300 p-2">
                          {condConfObj[condition.condition] ||
                            condition.condition}
                        </td>
                        <td className="border border-gray-300 p-2">
                          {/* Logic for displaying the target column */}
                          {`${
                            [
                              // "",
                              // "DUC Range",
                              // "DUC LC",
                              // "Master Range LC",
                              // "accuracy",
                              // "Master LC",
                              // "Master Range",
                              ...datasheetColumnName,
                            ][
                              Number(
                                condition.dsCol.includes("ds")
                                  ? condition.dsCol.split(".")[0].split("ds")[1]
                                  : condition.dsCol.split(".")[0]
                              ) -
                                1 +
                                (condition.dsCol.includes("ds") ? 0 : 0)
                            ]
                          }${
                            condition.dsCol.split(".")[0] === "4"
                              ? `.${
                                  condition.dsCol.split(".")[1]
                                    ? Number(condition.dsCol.split(".")[1])
                                    : condition.dsCol.split(".")[1]
                                }`
                              : ""
                          }`}
                        </td>
                        <td className="border border-gray-300 p-2">
                          <input
                            type="color"
                            value={condition.color}
                            style={{
                              backgroundColor: `${condition.color}`,
                              width: 70,
                              height: 40,
                              border: "1px solid white",
                              borderRadius: "20px",
                            }}
                            disabled
                          />
                        </td>
                        <td className="border border-gray-300 p-2">
                          <Button
                            size="small"
                            onClick={() => {
                              const tmpC = { ...condConfiguration };
                              const tmp = { ...tmpC.relations };

                              // Remove the specific condition
                              tmp[dC] = tmp[dC].filter(
                                (_, idx) => idx !== index
                              );

                              // Check if the array is now empty, then delete the key
                              if (tmp[dC].length === 0) {
                                delete tmp[dC]; // Remove the column if empty
                              }

                              tmpC.relations = { ...tmp };
                              setCondConfiguration(tmpC);
                            }}
                          >
                            <DeleteIcon style={{ color: "#8d7a7c" }} />
                          </Button>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr key={dC}>
                      <td className="border border-gray-300 p-2">
                        {datasheetColumnName[Number(dC.split("c")[1]) - 1]}
                      </td>
                      <td className="border border-gray-300 p-2">
                        {condConfObj[conditions.condition] ||
                          conditions.condition}
                      </td>
                      <td className="border border-gray-300 p-2">
                        {conditions.dsCol}
                      </td>
                      <td className="border border-gray-300 p-2">
                        {conditions.color}
                      </td>
                      <td className="border border-gray-300 p-2">
                        <Button
                          size="small"
                          onClick={() => {
                            const tmpC = { ...condConfiguration };
                            delete tmpC.relations[dC]; // Remove the condition
                            setCondConfiguration(tmpC);
                          }}
                        >
                          <DeleteIcon style={{ color: "#8d7a7c" }} />
                        </Button>
                      </td>
                    </tr>
                  );
                })}
              </table>
            </Grid>
          </Grid>
        </div>

        <div className="mt-5">
          <Typography variant="h6" component="h6">
            6. Set Custom Precision
          </Typography>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 my-5">
            <div className="w-full">
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">
                  Select ObservationSheet Column
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={selectedFormulaCol1}
                  label="Select column"
                  onChange={(e) => {
                    setSelectedFormulaCol1(e.target.value);
                  }}
                  size="small"
                >
                  {datasheetColumnName.map((columnName, index) => {
                    return (
                      <MenuItem value={"c" + (index + 1)}>
                        {columnName}
                      </MenuItem>
                    );
                  })}
                  <MenuItem value={"uncertainty"}>{"Uncertainty"}</MenuItem>
                </Select>
              </FormControl>
            </div>
            <div className="w-full">
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">
                  Select Target Columns
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={dsCol2}
                  label="Select column"
                  onChange={(e) => {
                    setDsCol2(e.target.value);
                    // setSelectedFormulaCol(e.target.value);
                  }}
                  size="small"
                >
                  {(() => {
                    let targetColMapping = {
                      1: "range higher",
                      2: "Out Off Range",
                      3: "DUC LC",
                      4: "Master Range: LC",
                      5: "accuracy",
                      6: "Greater LC",
                      7: "Actual Precision",
                      "standardRanges:cmv": "Master Range: CMV",
                    };

                    let menuItems = [];
                    menuItems = Object.keys(targetColMapping).map(
                      (key, index) => {
                        return (
                          <MenuItem value={key}>
                            {targetColMapping[key]}
                          </MenuItem>
                        );
                      }
                    );
                    datasheetColumnName.forEach((columnName, index) => {
                      menuItems.push(
                        <MenuItem value={"ds" + (index + 1)}>
                          datasheet: {columnName}
                        </MenuItem>
                      );
                    });
                    return menuItems;
                  })()}
                  <MenuItem value={"manual"}>Manual</MenuItem>
                </Select>
              </FormControl>
            </div>
            {/* {dsCol2 == 3 || dsCol2 == 4 ? ( */}
            <div className="w-full">
              <TextField
                id="outlined-basic"
                label="+ precision"
                size="small"
                fullWidth
                variant="outlined"
                inputProps={{
                  autoComplete: "off",
                }}
                value={plusPrecision}
                onChange={(e) => setPlusPrecision(e.target.value || "")}
              />
            </div>
            {dsCol2 == 4 ||
            dsCol2 == 6 ||
            dsCol2 == 8 ||
            String(dsCol2).includes("standardRanges") ||
            dsCol2 == "manual" ? (
              <Grid item xs={2}>
                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">
                    Select Std. Pref.
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={stdRangePref}
                    label="Select column"
                    onChange={(e) => {
                      setStdRangePref(e.target.value);
                      // setSelectedFormulaCol(e.target.value);
                    }}
                    size="small"
                  >
                    {[
                      "NA",
                      "1",
                      "2",
                      "3",
                      "4",
                      "5",
                      "6",
                      "7",
                      "8",
                      "9",
                      "10", //Here, stdRangePref is 10 for the supportive Standard Master.
                    ].map((columnName, index) => {
                      if (columnName === "NA")
                        return <MenuItem value={"null"}>{columnName}</MenuItem>;
                      else
                        return <MenuItem value={index}>{columnName}</MenuItem>;
                    })}
                  </Select>
                </FormControl>
              </Grid>
            ) : (
              ""
            )}
            <div className="w-full">
              <CButton
                variant="outlined"
                label={"add"}
                onClick={(e) => updateCustomPrecision()}
              ></CButton>
            </div>
          </div>

          <div className="md:w-[60%] my-5">
            <h4>Custom Precision mappings: </h4>
            <table className="w-full border border-gray-300 border-collapse text-center text-sm">
              <thead>
                <tr className="bg-gray-100">
                  <th className="border border-gray-300 p-2 w-[150px]">
                    Source Column
                  </th>
                  <th className="border border-gray-300 p-2 w-[200px]">
                    Target Column
                  </th>
                  <th className="border border-gray-300 p-2 w-[100px]">Pref</th>
                  <th className="border border-gray-300 p-2 w-[100px]">
                    Action
                  </th>
                </tr>
              </thead>
              <tbody>
                {Object.keys(customPrecision ? customPrecision : {}).map(
                  (dC) => (
                    <tr key={dC} className="border-t border-gray-300">
                      {[...[dC].concat(customPrecision[dC].split("."))]
                        .concat([""])
                        .map((col, idx) => {
                          if (idx === 0)
                            return (
                              <td
                                key={idx}
                                className="border border-gray-300 p-2"
                              >
                                {col !== "uncertainty"
                                  ? datasheetColumnName[
                                      Number(col.split("c")[1]) - 1
                                    ]
                                  : col}
                              </td>
                            );
                          else if (idx === 1) {
                            let lt0 = col?.split(extraPrecisionSplitter)[0],
                              lt1 =
                                lt0 == 2 || lt0 == 3
                                  ? col.includes("ds")
                                    ? col?.split(extraPrecisionSplitter)[1]
                                    : col?.split(extraPrecisionSplitter)[1]
                                  : "";
                            lt1 = lt1 ? extraPrecisionSplitter + lt1 : "";
                            return (
                              <td
                                key={idx}
                                className="border border-gray-300 p-2"
                              >
                                {(() => {
                                  let columns = {
                                    manual: "manual",
                                  };
                                  datasheetColumnName.forEach(
                                    (columnName, index) => {
                                      columns[
                                        `ds${index + 1}`
                                      ] = `datasheet: ${columnName}`;
                                    }
                                  );
                                  return columns[lt0] + lt1;
                                })()}
                              </td>
                            );
                          } else if (idx === 3)
                            return (
                              <td
                                key={idx}
                                className="border border-gray-300 p-2"
                              >
                                <Button size="sm">
                                  <DeleteIcon
                                    className="text-gray-400 hover:text-red-500 cursor-pointer"
                                    onClick={(e) => {
                                      let tmp = { ...customPrecision };
                                      delete tmp[dC];
                                      setCustomPrecision({ ...tmp });
                                    }}
                                  />
                                </Button>
                              </td>
                            );
                          return (
                            <td
                              key={idx}
                              className="border border-gray-300 p-2"
                            >
                              {col}
                            </td>
                          );
                        })}
                    </tr>
                  )
                )}
              </tbody>
            </table>
          </div>
        </div>

        {/* Additional Test Details */}
        <div style={{ width: "100%", marginTop: "16px" }}>
          <Typography variant="h6" component="h6">
            7. Additional Test Details
          </Typography>

          {/* Add new field row */}
          <div className="flex gap-3 items-center my-3 flex-wrap">
            {DEFAULT_TEST_DETAIL_FIELDS.map((field) => {
              const alreadyAdded = additionalTestDetails.some((f) => f.label === field.label); // check by label
              return (
                <Button
                  key={field.label}
                  variant="outlined"
                  size="small"
                  disabled={alreadyAdded}
                  startIcon={<AddIcon />}
                  onClick={() => {
                    if (!alreadyAdded) {
                      setAdditionalTestDetails([
                        ...additionalTestDetails,
                        { label: field.label }, // only label, no key
                      ]);
                    }
                  }}
                >
                  {field.label}
                </Button>
              );
            })}

            <Button
              variant="outlined"
              size="small"
              startIcon={<AddIcon />}
              onClick={() => {
                setAdditionalTestDetails([
                  ...additionalTestDetails,
                  { label: "" }, // only label
                ]);
              }}
            >
              Add New
            </Button>
          </div>

          {/* Render added fields */}
          <div className="p-3 mb-2">
            {additionalTestDetails?.length > 0 && (
              <Typography variant="h6" component="h6">
                Added Fields
              </Typography>
            )}
            <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4 my-3">
              {additionalTestDetails.map((field, index) => (
                <div key={index} className="w-full">  {/* use index as key now */}
                  <OutlinedInput
                    size="small"
                    fullWidth
                    value={field.label}
                    placeholder="Field heading"
                    onChange={(e) => {
                      const updated = [...additionalTestDetails];
                      updated[index] = { label: e.target.value }; // only label
                      setAdditionalTestDetails(updated);
                    }}
                    endAdornment={
                      <InputAdornment position="end">
                        <IconButton
                          edge="end"
                          onClick={() => {
                            const updated = additionalTestDetails.filter((_, i) => i !== index);
                            setAdditionalTestDetails(updated);
                          }}
                        >
                          <CloseIcon />
                        </IconButton>
                      </InputAdornment>
                    }
                  />
                </div>
              ))}
            </div>
          </div>
        </div>

        <div style={{ width: "100%" }}>
          <Typography variant="h6" component="h6">
            8. Table Instructions
          </Typography>
          <textarea
            className="w-full border border-gray-300 rounded-md p-2 focus:outline-none focus:ring-2 focus:ring-blue-400"
            value={tableInstruction}
            onChange={(e) => setTableInstruction(e.target.value)}
          />
        </div>

        <br />
        <div style={{ display: "flex" }}>
          <Grid item xs={4} style={{ alignItems: "start" }}>
            <FormControlLabel
              classes={{
                alignItems: "left",
              }}
              style={{ display: "flex" }}
              control={
                <Checkbox
                  checked={certificateTableStatus === 0 ? true : false}
                  onChange={(e) => {
                    setCertificateTableStatus(e.target.checked == true ? 0 : 1);
                  }}
                />
              }
              label="Hide in certificate"
            />
          </Grid>
        </div>
      </div>

      {/* certificate table confiurations */}
      <div>
        <Divider sx={{ mt: 5 }}>
          <Chip
            label="Certificate table configuration"
            variant="outlined"
            sx={{ fontSize: "16px", fontWeight: "600" }}
          />
        </Divider>
        <br />

        <div className="flex gap-4 items-center my-3">
          <Typography variant="h6" component="h6">
            1.
          </Typography>
          <AddButton
            id="btn-add-column"
            label="Add columns"
            icon={<AddIcon fontSize="small" />}
            onClick={() => addCertificateColumn()}
          />
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 px-5">
          {certificateColumnName.map((column, index) => (
            <div className="w-full">
              <OutlinedInput
                id="outlined-adornment-password"
                label={"column " + (index + 1)}
                value={column}
                placeholder={"column " + (index + 1)}
                onChange={(e) => {
                  updateCertificateColumnName(e.target.value, index);
                }}
                size="small"
                endAdornment={
                  <InputAdornment position="end">
                    <IconButton
                      onClick={() => {
                        deleteCertificateColumn(index);
                      }}
                      edge="end"
                    >
                      <CloseIcon />
                    </IconButton>
                  </InputAdornment>
                }
              />
            </div>
          ))}
        </div>
        <br />
        <div>
          <Typography variant="h6" component="h6">
            2. Define common header
          </Typography>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 my-3">
            <div className="w-full md:text-center">
              <FormControlLabel
                control={<Checkbox />}
                label="Has common header"
                checked={certificateConfiguration?.hasCommonHeader}
                onChange={(e) => {
                  updateCertificateConfiguration(
                    "hasCommonHeader",
                    null,
                    e.target.checked
                  );
                }}
              />
            </div>
            <div className="col-span-1 sm:col-span-2 md:col-span-3 lg:col-span-3">
              <TextField
                id="outlined-basic"
                label="Define common header"
                placeholder="Define common header (, for column separation, $: for empty column)"
                size="small"
                fullWidth
                variant="outlined"
                inputProps={{
                  autoComplete: "off",
                }}
                value={certificateConfiguration?.commonHeaderConfig || ""}
                onChange={(e) =>
                  updateCertificateConfiguration(
                    "commonHeaderConfig",
                    null,
                    e.target.value
                  )
                }
              />
            </div>
            {/* <div className="w-full">
              <CButton
                variant="text"
                size="small"
                label={<HelpCenterIcon />}
                onClick={handleOpen}
              ></CButton>
            </div> */}
          </div>
        </div>

        <div className="mt-2">
          <Typography variant="h6" component="h6">
            3. Set Relationship
          </Typography>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 my-5">
            <div className="w-full">
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">
                  Select ObservationSheet column
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={selectedDatasheetRelCol}
                  label="Select column"
                  onChange={(e) => {
                    setSelectedDatasheetRelCol(e.target.value);
                  }}
                  size="small"
                >
                  {datasheetColumnName.map((columnName, index) => {
                    return (
                      <MenuItem value={"c" + (index + 1)}>
                        {columnName}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            </div>
            <div className="w-full">
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">
                  Select certificate column
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={selectedCertRelCol}
                  label="Select column"
                  onChange={(e) => {
                    setSelectedCertRelCol(e.target.value);
                  }}
                  size="small"
                >
                  {certificateColumnName.map((columnName, index) => {
                    return (
                      <MenuItem value={"c" + (index + 1)}>
                        {columnName}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            </div>
            <div className="w-full">
              <CButton
                variant="outlined"
                label={"add"}
                onClick={(e) => updateCertificateConfiguration("relations")}
              ></CButton>
            </div>
          </div>
          <div className="w-[60%] overflow-x-auto">
            <table className="w-full border border-gray-300 border-collapse text-center font-sans">
              <thead>
                <tr className="bg-gray-100">
                  <th className="border border-gray-300 p-2 w-[200px]">
                    Certificate Column
                  </th>
                  <th className="border border-gray-300 p-2 w-[150px]">
                    ObservationSheet Column
                  </th>
                  <th className="border border-gray-300 p-2 w-[100px]">
                    Action
                  </th>
                </tr>
              </thead>
              <tbody>
                {Object.keys(
                  certificateConfiguration["relations"]
                    ? certificateConfiguration["relations"]
                    : {}
                ).map((dC) => (
                  <tr
                    key={dC}
                    className="border-b border-gray-300 last:border-b-0"
                  >
                    {[
                      ...[dC].concat([
                        certificateConfiguration["relations"][dC],
                      ]),
                    ]
                      .concat([""])
                      .map((col, idx) => {
                        if (idx === 0)
                          return (
                            <td
                              key={idx}
                              className="border border-gray-300 p-2"
                            >
                              {
                                certificateColumnName[
                                  Number(col?.split("c")[1]) - 1
                                ]
                              }
                            </td>
                          );
                        else if (idx === 1) {
                          return (
                            <td
                              key={idx}
                              className="border border-gray-300 p-2"
                            >
                              {
                                datasheetColumnName[
                                  Number(col?.split("c")[1]) - 1
                                ]
                              }
                            </td>
                          );
                        } else if (idx === 2)
                          return (
                            <td
                              key={idx}
                              className="border border-gray-300 p-2"
                            >
                              <Button size="sm">
                                <DeleteIcon
                                  className="text-gray-400 hover:text-gray-700 cursor-pointer"
                                  onClick={(e) => {
                                    let tmp = { ...certificateConfiguration };
                                    let tmp1 = {
                                      ...certificateConfiguration["relations"],
                                    };
                                    delete tmp1[dC];
                                    tmp["relations"] = { ...tmp1 };
                                    setCertificateConfiguration({ ...tmp });
                                  }}
                                />
                              </Button>
                            </td>
                          );
                        return (
                          <td key={idx} className="border border-gray-300 p-2">
                            {col}
                          </td>
                        );
                      })}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
           {/* Summary Columns */}
          <div style={{ display: "flex", marginTop: "15px" }}>
            <Grid item xs={4} style={{ alignItems: "start" }}>
              <Typography variant="h6" component="h6" style={{ marginBottom: "10px" }}>
                Certificate Summary Columns Mapping
              </Typography>
              <Autocomplete
                multiple
                id="summary-columns-select"
                options={datasheetColumnName.map((col, index) => ({
                  label: col,
                  value: `c${index + 1}`
                }))}
                value={summaryColumns.map((col) => {
                  const index = parseInt(col.replace('c', '')) - 1;
                  return {
                    label: datasheetColumnName[index] || col,
                    value: col
                  };
                })}
                onChange={(event, newValue) => {
                  setSummaryColumns(newValue.map(item => item.value));
                }}
                getOptionLabel={(option) => option.label}
                isOptionEqualToValue={(option, value) => option.value === value.value}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    label="Summary Columns"
                    placeholder="Select columns"
                    size="small"
                  />
                )}
                renderTags={(value, getTagProps) =>
                  value.map((option, index) => (
                    <Chip
                      label={option.label}
                      {...getTagProps({ index })}
                      size="small"
                    />
                  ))
                }
                style={{ minWidth: "300px" }}
              />
            </Grid>
          </div>
        </div>
      </div>

      <br />
      <div className="flex gap-10 mt-5 justify-end ">
        <CancelButton
          id="btn-cancel"
          label="Cancel"
          outline
          onClick={() => {
            if (window.confirm("Are you sure you want to cancel?")) {
              window.history.back();
            }
          }}
        />
        <SaveAndUpdate
          id="btn-add-outline"
          label={params.id != 0 ? "Update" : "Save"}
          onClick={() => {
            if (!tableName) {
              toast.error("tableName is required");
              return;
            }
            if (!materialId) {
              toast.error("Please select a material");
              return;
            }
            onSubmit();
          }}
        />
      </div>

      <ToastContainer />
      {renderHelpModal()}
    </>
  );
};

export default EditTemplate;
